import { ref, computed } from "vue";
import { defineStore } from "pinia";
import router from "../router";
import { useHttpStore } from "@/stores/http";
import CryptoJS from "crypto-js";
import * as converter from "json-2-csv";

export const useSystemStore = defineStore("system", () => {
  const httpStore = useHttpStore();

  const storeData = ref({
    languages: [],
    languageDictionary: [],
    elementLinks: [],
    assets: {},
  });

  const headerColor = ref("#0d2155");
  const userDetail = ref(null);
  const isAdmin = ref(false);
  const requestedRoute = ref("");

  const defaultDataLoaded = ref(false);
  const languageDictionary = ref([]);
  // const languages = ref([]);
  // const elementLinks = ref([])
  const selectedLanguage = ref("");

  const messageVisible = ref(false);
  const messageText = ref("");
  const messageList = ref([]);
  const messageTimeout = ref(10000); // 10 SECONDS DEFAULT
  const messageColor = ref("");
  
  const systemView = computed(() => {
    if (userDetail.value.userType !== undefined) {
      if (userDetail.value.userType.trim() == "Partner") {
        return "Partner";
      } else if (userDetail.value.userType.trim() == "Distributor") {
        return "Distributor";
      } else if (userDetail.value.userType.trim() == "TIC_Admin") {
        return "TIC";
      } else if (
        userDetail.value.userType.trim() == "Dell" ||
        userDetail.value.userType.trim() == "TP" ||
        userDetail.value.userType.trim() == "PAM" ||
        userDetail.value.userType.trim() == "Dell Marketing" ||
        userDetail.value.userType.trim() == "Dell"
      ) {
        return "Dell";
      }
    } else {
      return "";
    }
  });

  const showLoading = (show) => {
    httpStore.showLoading = show;
  };

  const setData = (property, value) => {
    if (property == "languages") {
      var t = "";
    }
    var ciphertext = CryptoJS.AES.encrypt(
      JSON.stringify(value),
      import.meta.env.VITE_ENCKEY
    ).toString();

    storeData.value[property] = ciphertext;

    sessionStorage.setItem("assets", storeData.value.assets);
  };

  const getData = (property) => {
    try {
      var ciphertext = storeData.value[property];
      var bytes = CryptoJS.AES.decrypt(ciphertext, import.meta.env.VITE_ENCKEY);
      var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

      return decryptedData;
    } catch (error) {
      return {};
    }
  };

  const downloadCsvFile = (data, filename) => {
    const csv = converter.json2csv(data);
    const anchor = document.createElement("a");
    anchor.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
    anchor.target = "_blank";
    anchor.download = filename;
    anchor.click();
  };

  const reloadAllData = () => {
    httpStore.apiAll([
      getAllLanguages(),
      getLanguageDictionary()]
    ).then(result => {
      selectedLanguage.value = ''
      defaultDataLoaded.value = true
  
      var lsLanguage = localStorage.getItem("selectedLanguage")
      selectedLanguage.value = lsLanguage == null || lsLanguage == '' ? 'en' : lsLanguage
      localStorage.setItem("selectedLanguage", selectedLanguage.value)
    }).catch(error => {
      var t = error
    })
  }

  const uploadFile = (base64Data) => {
    var params = {
      base64Data,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "system/UploadFile", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const downloadPartnerEVoucher = (eVoucherNumber) => {
    var params = {
      eVoucherNumber
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "file/DownloadPartnerEVoucher", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const downloadDistributorEVoucher = (eVoucherNumber) => {
    var params = {
      eVoucherNumber
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "file/DownloadDistributorEVoucher", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getPartnerBonusDashboardReport = (quarter, country) => {
    var params = {
      quarter,
      country,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetPartnerBonusDashboardReport", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getDistributorBonusDashboardPartners = (quarter) => {
    var params = {
      quarter,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetDistributorBonusDashboardPartners", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getDistributorBonusDashboard = (quarter, country, partnerId) => {
    var params = {
      quarter,
      country,
      partnerId,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetDistributorBonusDashboard", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const submitRedemption = (distiId, rewardsRedeemedUSD) => {
    var params = {
      distiId,
      rewardsRedeemedUSD,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "system/SubmitRedemption", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getDistributorHomeDashboard = (quarter, country, distiId, region, masterDistributor) => {
    var params = {
      Quarter: quarter,
      DistributorCountry: country,
      DistributorAffinityId: distiId,
      Region: region,
      MasterDistributor: masterDistributor
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetDistributorHomeDashboard", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getPartnerRedemptionHedgeRate = () => {
    var params = {};
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "system/GetPartnerRedemptionHedgeRate", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  // const getDistributorRedemptionDistributors = (quarter) => {
  //   var params = {
  //     quarter,
  //   };
  //   return new Promise((resolve, reject) => {
  //     httpStore
  //       .api("post", "system/GetDistributorRedemptionDistributors", params)
  //       .then((res) => {
  //         resolve(res);
  //       })
  //       .catch((error) => {
  //         reject(error);
  //       });
  //   });
  // };

  const getDistributorReferralReport = () => {
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetDistributorReferralReport", {})
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getDistributorRedemptionData = (quarter, distiId, country) => {
    var params = {
      quarter,
      distiId,
      country,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "system/GetDistributorRedemptionData", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getDistributorRedemptionBankedData = (quarter, country) => {
    var params = {
      quarter,
      country,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "system/GetDistributorRedemptionBankedData", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getCreditNoteReport = (quarters, countries, creditNoteNumber) => {
    const quarterList = Array.isArray(quarters)
      ? quarters.filter((q) => q != null && q !== "")
      : quarters
        ? [quarters]
        : [];
    const countryList = Array.isArray(countries)
      ? countries.filter((c) => c != null && c !== "")
      : countries
        ? [countries]
        : [];
    var params = {
      quartersCsv: quarterList.length > 0 ? quarterList.join(",") : "",
      countriesCsv: countryList.length > 0 ? countryList.join(",") : "",
      creditNoteNumber,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetCreditNoteReport", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getPartnerEVoucherReport = (quarter, country, evoucherNumber) => {
    var params = {
      quarter,
      country,
      evoucherNumber,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetPartnerEVoucherReport", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getDistributorEVoucherReport = (quarters, countries, evoucherNumber) => {
    const quarterList = Array.isArray(quarters)
      ? quarters.filter((q) => q != null && q !== "")
      : quarters
        ? [quarters]
        : [];
    const countryList = Array.isArray(countries)
      ? countries.filter((c) => c != null && c !== "")
      : countries
        ? [countries]
        : [];
    var params = {
      quartersCsv: quarterList.length > 0 ? quarterList.join(",") : "",
      countriesCsv: countryList.length > 0 ? countryList.join(",") : "",
      evoucherNumber,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetDistributorEVoucherReport", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getPartnerPerformanceReport = (
    quarter,
    country,
    distiId,
    partnerId,
    accepted
  ) => {
    distiId = distiId == null ? 0 : distiId;
    partnerId = partnerId == null ? 0 : partnerId;

    var params = {
      quarter,
      country,
      distiId,
      partnerId,
      accepted,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "system/GetPartnerPerformanceReport", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getCommsSendList = (quarters) => {
    var params = {
      quarters,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "system/GetCommsSendList", params, {
          showLoading: true,
          timeout: 0,
        })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getPartnerPerformanceAllPotentialPartners = (
    quarter,
    country,
    distiId
  ) => {
    var params = {
      quarter,
      country,
      distiId,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "system/GetPartnerPerformanceAllPotentialPartners", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getPartnerPerformancePartners = (quarter, country, distiId) => {
    var params = {
      quarter,
      country,
      distiId,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "system/GetPartnerPerformancePartners", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getPartnerPerformanceCountries = (quarter) => {
    var params = {
      quarter,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "system/GetPartnerPerformanceCountries", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getPartnerPerformanceRegions = () => {
    var params = {
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetPartnerPerformanceRegions", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getPartnerPerformanceMasterDistributors = () => {
    var params = {
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetPartnerPerformanceMasterDistributors", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getPartnerPerformanceDistributors = (quarter, country) => {
    var params = {
      quarter,
      country,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "system/GetPartnerPerformanceDistributors", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getFAQs = () => {
    var params = {};
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetFaqs", params)
        .then((res) => {
          if (res.success === true) {
            setData("faqs", res.faqItems);
            var t = getData("faqs");
          }
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getDistributorDashboardData = (quarter, country) => {
    var params = {
      quarter,
      country,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetDistributorDashboardData", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  // const getElementLinks = () => {
  //   var params = {};
  //   return new Promise((resolve, reject) => {
  //     httpStore
  //       .api("get", "system/GetElementLinks", params)
  //       .then((res) => {
  //         if (res.success === true) {
  //           setData("elementLinks", res.elementLinks);
  //         }
  //         resolve(res);
  //       })
  //       .catch((error) => {
  //         reject(error);
  //       });
  //   });
  // };

  const getEligibleProducts = (quarter) => {
    quarter = quarter == undefined ? "" : quarter;
    var params = {
      quarter: quarter,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetEligibleProducts", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getFile = (filename, container) => {
    var params = {
      filename,
      container,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "file/getFileUrl", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const sendContactUsEmail = (queryCategory, message) => {
    var params = {
      queryCategory: queryCategory,
      message: message,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "system/SendContactUsEmail", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const updateUserLanguage = (language, iso) => {
    var params = {
      // newLanguage: language,
      newLanguageIso: iso,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "users/UpdateUserLanguage", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getUserDetails = () => {
    var params = {};
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetUserDetails", params)
        .then((res) => {
          if (res.success) {
            userDetail.value = res.userDetail;
          }
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const isUATOpen = () => {
    var params = {};
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/IsUATOpen", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getPartnerRedemptionDistributors = (quarter) => {
    var params = {
      quarter,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "system/GetPartnerRedemptionDistributors", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getRewardsAccountData = (quarter) => {
    var params = {
      quarter,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetRewardsAccountData", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getRedemptionSummary = (quarter) => {
    var params = {
      quarter: quarter,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetRedemptionSummary", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getPartnerHomeData = (affinityId, quarter) => {
    var params = {
      affinityId: affinityId,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetPartnerHomeData", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getMyPerformanceData = (affinityId, quarter) => {
    var params = {
      affinityId: affinityId,
      quarter: quarter,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetMyPerformanceData", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getMyNonEligiblePerformanceData = (affinityId, quarter) => {
    var params = {
      affinityId: affinityId,
      quarter: quarter,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetMyNonEligiblePerformanceData", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const linkElementToDictionary = (elementId, dictionaryId, page, note) => {
    var params = {
      elementId: elementId,
      dictionaryId: dictionaryId,
      page: page,
      note: note,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "system/LinkElementToDictionary", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const unlinkElementFromDictionary = (elementId) => {
    var params = {
      elementId
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "system/UnlinkElementFromDictionary", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getAllLanguages = (username, password) => {
    var params = {};
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetAllLanguages", params, { showLoading: false })
        .then((res) => {
          if (res.success === true) {
            setData("languages", res.languages);
          }
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getLanguageDictionary = () => {
    var params = {};
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetLanguageDictionary", params, {
          showLoading: false,
        })
        .then((res) => {
          if (res.success === true) {
            languageDictionary.value = res.dictionary;
            // setData('languageDictionary', res.dictionary)
          }
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const routerTo = (routeName) => {
    if (routeName !== undefined) {
      router.push({ name: routeName });
    }
  };

  const showMessage = (msg, options) => {
    messageList.value = [];

    if (options != undefined) {
      messageTimeout.value =
        options.timeout != undefined ? options.timeout : 10000;
      messageColor.value = options.color != undefined ? options.color : "info";
    }

    if ((typeof msg === "string") | (msg instanceof String)) {
      messageList.value.push(msg);
    } else if (msg.constructor === Array) {
      messageList.value = msg;
    }
    messageVisible.value = true;
  };

  const footerLinksNoauth = [
    { text: "© Dell Technologies 2024", enabled: false },
    { text: "Terms Of Use", enabled: true, routeName: "noauth-terms-of-use" },
    {
      text: "Privacy Statement",
      enabled: true,
      routeName: "noauth-privacy-statement",
    },
    {
      text: "Cookies Information",
      enabled: true,
      routeName: "noauth-cookies-information",
    },
  ];

  const footerLinks = [
    { text: "© Dell Technologies 2024", enabled: false },
    { text: "Terms Of Use", enabled: true, routeName: "terms-of-use" },
    {
      text: "Privacy Statement",
      enabled: true,
      routeName: "privacy-statement",
    },
    {
      text: "Cookies Information",
      enabled: true,
      routeName: "cookies-information",
    },
  ];

  const getDictionaryByCode = (code) => {
    const res = languageDictionary.value.filter((o) => {
      return o.code == code && o.languageCode == selectedLanguage.value;
    });

    return res;
  };

  const openUrl = (url) => {
    window.open(url, "_blank").focus();
  };

  const downloadFile = (filePath, fileName) => {
    var link = document.createElement("a");
    link.href = filePath;
    link.download = fileName;
    setTimeout(function () {
      link.click();
    }, 1000);
  };

  const openPdfInNewWindow = (dataUrl, filename) => {
    const base64 = dataUrl.split(',')[1];
    const byteCharacters = atob(base64);
    const byteNumbers = new Uint8Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const blob = new Blob([byteNumbers], { type: 'application/pdf' });
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, '_blank');
  }

  const splitCamelCase = (str) => {
    return str.replace(/([a-z])([A-Z])/g, "$1 $2");
  };

  const getWeeksInQuarter = () => {
    return [
      "Week 1",
      "Week 2",
      "Week 3",
      "Week 4",
      "Week 5",
      "Week 6",
      "Week 7",
      "Week 8",
      "Week 9",
      "Week 10",
      "Week 11",
      "Week 12",
      "Week 13",
    ];
  };

  const getCurrentWeekInQuarter = (weeks, quarter) => {
    const match = quarter.match(/q([1-4])/i);

    if (!match) {
      return "";
    }

    const val = parseInt(match[1], 10);

    const date = new Date();
    const currentDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );
    let startDate;

    if (val === 1) {
      startDate = new Date(currentDate.getFullYear(), 0, 31); // February 1
    } else if (val === 2) {
      startDate = new Date(currentDate.getFullYear(), 4, 3); // May 1
    } else if (val === 3) {
      startDate = new Date(currentDate.getFullYear(), 7, 2); // August 1
    } else {
      startDate = new Date(currentDate.getFullYear(), 10, 1); // November 1
    }

    if (startDate > currentDate) {
      return "";
    }

    const currentWeek = weeksBetween(startDate, currentDate) - 1;

    return weeks[currentWeek];
  };

  const startOfWeek = (dt) => {
    const day = 24 * 60 * 60 * 1000;
    const weekday = dt.getDay();
    return new Date(dt.getTime() - Math.abs(0 - weekday) * day);
  };

  const weeksBetween = (d1, d2) => {
    const week = 7 * 24 * 60 * 60 * 1000;
    return Math.ceil((startOfWeek(d2) - startOfWeek(d1)) / week);
  };

  const getEvoucher = (evoucher) => {
    var params = {
      EVoucherNumber: evoucher,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetEvoucher", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getEvouchers = (partnerAffinityId) => {
    var params = {
      SearchBy: partnerAffinityId,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetEvouchers", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const recalculateLocalValue = (usdAmount, localCurrency, partnerCountry) => {
    var params = {
      USDAmount: usdAmount,
      LocalCurrency: localCurrency,
      PartnerCountry: partnerCountry
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/RecalculateLocalValue", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const reissueEVoucher = (evoucher) => {
    var params = {
      EVoucherControlDTO: evoucher
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "system/ReissueEVoucher", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const resendEVoucherEmail = (evoucher) => {
    var params = {
      EVoucherControlDTO: evoucher
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "system/ResendEVoucherEmail", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const cancelEVoucher = (evoucher) => {
    var params = {
      EVoucherControlDTO: evoucher
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "system/CancelEVoucher", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const extendExpiryDate = (evoucher) => {
    var params = {
      EVoucherControlDTO: evoucher
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "system/ExtendExpiryDate", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getQuarters = () => {
    var params = {};
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetQuarters", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
 
  const getPartnerBonusQualifier = (affinityId) => {
    var params = {
      SearchBy: affinityId
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetPartnerBonusQualifier", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getEVoucherReferenceData = () => {
    var params = {      
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetEVoucherReferenceData", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const markEVoucherReferenceAsUtilised = (data, batchNumber) => {
    var params = {     
      eVoucherReferences: data,
      batchNumber: batchNumber
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "system/MarkEVoucherReferenceAsUtilised", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getAutoRedemptions = () => {
    var params = {     
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetAutoRedemptions", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getAutoRedemptionState = () => {
    var params = {};
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetAutoRedemptionState", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const setAutoRedemptionState = (state) => {
    var params = {   
      autoRedemptionState: state  
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "system/SetAutoRedemptionState", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const submitAutoRedemptions = (data) => {
    var params = {   
      autoRedemptions: data  
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "system/SubmitAutoRedemptions", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getLastAutoRedemptionPeriod = () => {
    var params = {};
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetLastAutoRedemptionPeriod", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getAutoRedemptionPeriods = () => {
    var params = {};
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetAutoRedemptionPeriods", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getLastAutoRedemptionResult = (quarter) => {
    var params = {
      quarter: quarter ?? ""
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetLastAutoRedemptionResult", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const updateEVouchersAsExpired = (quarter) => {
    var params = {
      quarter
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "system/UpdateEVouchersAsExpired", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getHedgeRates = (quarter) => {
    var params = {
      Quarter: quarter,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetHedgeRates", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getEVoucherControlRecords = (quarter, partnerAffinityId) => {
    var params = {
      Quarter: quarter,
      PartnerAffinityId: partnerAffinityId,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetEVoucherControlRecords", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getManualSingleAutoRedemptionOptions = (eVoucherControlId) => {
    var params = {
      EVoucherControlId: eVoucherControlId,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetManualSingleAutoRedemptionOptions", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const submitManualSingleAutoRedemption = (eVoucherControlId, redeemMode, distiId) => {
    var params = {
      EVoucherControlId: eVoucherControlId,
      RedeemMode: redeemMode,
      DistiId: distiId || 0,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "system/SubmitManualSingleAutoRedemption", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };


  const getObsfdcRecords = () => {
    var params = {};
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "system/GetObsfdcRecords", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const updateObsfdcEmail = (id, emailDomain) => {
    var params = {
      id,
      emailDomain,
    };
    return new Promise((resolve, reject) => {
      httpStore
        .api("post", "system/UpdateObsfdcEmail", params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  
  return {
    userDetail,
    systemView,
    headerColor,
    isAdmin,
    messageVisible,
    messageText,
    messageColor,
    messageList,
    messageTimeout,
    languageDictionary,
    // languages,
    selectedLanguage,
    footerLinksNoauth,
    footerLinks,
    // elementLinks,
    defaultDataLoaded,
    storeData,
    requestedRoute,
    openUrl,
    getDictionaryByCode,
    showMessage,
    routerTo,
    getAllLanguages,
    getLanguageDictionary,
    linkElementToDictionary,
    unlinkElementFromDictionary,
    getMyPerformanceData,
    getMyNonEligiblePerformanceData,
    getPartnerHomeData,
    isUATOpen,
    getUserDetails,
    getRedemptionSummary,
    updateUserLanguage,
    sendContactUsEmail,
    getFile,
    getEligibleProducts,
    downloadFile,
    showLoading,
    // getElementLinks,
    getData,
    setData,
    getFAQs,
    getDistributorDashboardData,
    getPartnerPerformanceDistributors,
    getPartnerPerformanceCountries,
    getPartnerPerformancePartners,
    getPartnerPerformanceAllPotentialPartners,
    getPartnerPerformanceReport,
    getCommsSendList,
    getDistributorEVoucherReport,
    getPartnerEVoucherReport,
    getCreditNoteReport,
    uploadFile,
    getDistributorReferralReport,
    getDistributorRedemptionData,
    getDistributorRedemptionBankedData,
    // getDistributorRedemptionDistributors,
    getRewardsAccountData,
    getPartnerRedemptionDistributors,
    getPartnerRedemptionHedgeRate,
    submitRedemption,
    downloadCsvFile,
    getDistributorHomeDashboard,
    getDistributorBonusDashboard,
    getDistributorBonusDashboardPartners,
    splitCamelCase,
    getQuarters,
    getWeeksInQuarter,
    getCurrentWeekInQuarter,
    getPartnerBonusDashboardReport,
    reloadAllData,
    getEvoucher,
    getEvouchers,
    recalculateLocalValue,
    reissueEVoucher,
    resendEVoucherEmail,
    cancelEVoucher,
    extendExpiryDate,
    downloadPartnerEVoucher,
    downloadDistributorEVoucher,
    openPdfInNewWindow,
    getPartnerBonusQualifier,
    getPartnerPerformanceRegions,
    getPartnerPerformanceMasterDistributors,
    getEVoucherReferenceData,
    markEVoucherReferenceAsUtilised,
    getAutoRedemptions,
    getAutoRedemptionState,
    setAutoRedemptionState,
    submitAutoRedemptions,
    getLastAutoRedemptionPeriod,
    getAutoRedemptionPeriods,
    getLastAutoRedemptionResult,
    updateEVouchersAsExpired,
    getHedgeRates,
    getEVoucherControlRecords,
    getManualSingleAutoRedemptionOptions,
    submitManualSingleAutoRedemption,
    getObsfdcRecords,
    updateObsfdcEmail
  };
});
